import request from "@/api/request";

// 个人中心 修改信息保存
export const update = (data) => {
  return request({
    url: "/apply-user/doSubmit",
    method: "POST",
    params: data,
  });
};
//  重新设置管理员密码
export const reset = (data) => {
  return request({
    url: "/user/setNewPassword",
    method: "POST",
    params: data,
  });
};
//  图片上传
export const upload = (data) => {
  return request({
    url: "/attachment/upload",
    method: "POST",
    params: data,
  });
};
//  图片上传 获取文件
export const getPhoto = (data) => {
  return request({
    url: "/attachment/getPhoto",
    method: "GET",
    params: data,
  });
};
//  添加图片
export const saveAttachment = (data) => {
  return request({
    url: "/attachment/saveAttachment",
    method: "POST",
    params: data,
  });
};
//  删除图片
export const deleteAttachment = (data) => {
  return request({
    url: "/attachment/deleteAttachment",
    method: "POST",
    params: data,
  });
};
//  更新图片
export const updateAttachment = (data) => {
  return request({
    url: "/attachment/updateAttachment",
    method: "POST",
    params: data,
  });
};
//  查询图片id 根据projectId,type查询
export const queryByNoBusiness = (data) => {
  return request({
    url: "/attachment/queryByAttachment",
    method: "POST",
    params: data,
  });
};
//  登录
export const login = (data) => {
  return request({
    url: "/login",
    withCredentials:true,
    method: "POST",
    params: data,
  });
};
//  退出登录
export const logout = (data) => {
  return request({
    url: "/logout",
    method: "POST",
    params: data,
  });
};
//  注册
export const register = (data) => {
  return request({
    url: "/register",
    method: "POST",
    params: data,
  });
};
//  注册评审专家时填写个人信息
export const examMessageAdd = (data) => {
  return request({
    url: "/experts-user/doSubmit",
    method: "POST",
    params: data,
  });
};
//  获取Session用户信息
export const session = (data) => {
  return request({
    url: "/user/session",
    method: "GET",
    params: data,
  });
};
//  根据用户id获取信息
export const queryApplyInfoByUserId = (data) => {
  return request({
    url: "/apply-user/queryApplyInfoByUserId",
    method: "POST",
    params: data,
  });
};
//  根据用户id修改评审专家信息
export const expertsUpdate = (data) => {
  return request({
    url: "/experts-user/doSubmit",
    method: "POST",
    params: data,
  });
};

//  根据用户id修改评审专家信息
export const InitPassword = (data) => {
  return request({
    url: "/experts-user/setInitialPassword",
    method: "POST",
    params: data,
  });
};
export const removeParticipantsUser = (data) => {
  return request({
    url: "/participants-user/remove",
    method: "POST",
    params: data,
  });
};
